export { default as ScrollToTop } from "./ScrollToTop";
export { default as Image } from "./Image";
export { default as Logo } from "./Logo";
export { default as LanguageSwitcher } from "./LanguageSwitcher";
export { default as Modal } from "./Modal";
export { default as Slider } from "./Slider";
export { default as Footer } from "./Footer";
export { default as Header } from "./Header";
export { default as Button } from "./Button";
export { default as BackgroundImage } from "./BackgroundImage";
export { default as ButtonGroup } from "./ButtonGroup";
export { default as LoadingSlider } from "./LoadingSlider";
export { default as SliderWithLoading } from "./SliderWithLoading";
export { default as ButtonScrollToSection } from "./ButtonScrollToSection";
export { default as NewsArticleCard } from "./NewsArticleCard";
export { default as NewsArticleSummary } from "./NewsArticleSummary";
export { default as GradientPage } from "./GradientPage";
export { default as InputField } from "./InputField";
export { default as PrivacyPolicy } from "./PrivacyPolicy";



// WEBPACK FOOTER //
// ./src/components/index.js